/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITrimester } from 'app/shared/model/trimester.model';
import { ILabPrescription } from 'app/shared/model/lab-prescription.model';
import { IVitals } from 'app/shared/model/vitals.model';
import { IAppointments } from 'app/shared/model/appointments.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IPregnancyCase } from 'app/shared/model/pregnancy-case.model';

export interface ITrimesterObservation {
  id?: string;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  trimester?: ITrimester | null;
  labPrescription?: ILabPrescription | null;
  vitals?: IVitals | null;
  appointment?: IAppointments | null;
  patient?: IGlucoUser | null;
  pregnancy?: IPregnancyCase | null;
}

export const defaultValue: Readonly<ITrimesterObservation> = {
  active: false,
  draft: false,
};
